import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSetupFlow } from 'accounts/hooks/homeowners/use-setup-flow';
import { fetchPropertyTimelines } from 'store/redux/homeowner-accounts/actions';
import { useSelectedProperty } from './use-selected-property';

export function useTimeline() {
  const dispatch = useDispatch();
  const { selectedProperty } = useSelectedProperty();
  const { unitIds, units } = useSetupFlow();
  // The units come off `useSetupFlow`'s context, which declares them as `any`;
  // without a type argument this state infers `undefined` from the empty initial
  // value and cannot hold the unit the effect below sets.
  const [selectedUnit, setSelectedUnit] = useState<any>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      if (selectedProperty && units) {
        await dispatch(fetchPropertyTimelines(unitIds));

        const selectedUnitId =
          selectedProperty.getUnitsWithAgreements()?.[0]?.basicInfo?.unitId;
        const newSelectedUnit = units?.find(
          (unit: any) => unit.basicInfo.unitId === selectedUnitId,
        );

        if (newSelectedUnit?.basicInfo) {
          newSelectedUnit.basicInfo.timeZone =
            selectedProperty.getUnitsWithAgreements()?.[0]?.basicInfo?.timeZone;
        }

        setSelectedUnit(newSelectedUnit);
        setLoading(false);
      }
    };

    init();
  }, [selectedProperty, units]);

  return { selectedUnit, loading };
}
